/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GroupedTrendItem } from "./GroupedTrendItem";
import {
    GroupedTrendItemFromJSON,
    GroupedTrendItemFromJSONTyped,
    GroupedTrendItemToJSON,
} from "./GroupedTrendItem";

/**
 *
 * @export
 * @interface GroupedChargingSuccessRateTrendResponse
 */
export interface GroupedChargingSuccessRateTrendResponse {
    /**
     * Array of trend data grouped by the requested grouping (device, device group, org, etc.)
     * @type {Array<GroupedTrendItem>}
     * @memberof GroupedChargingSuccessRateTrendResponse
     */
    groups?: Array<GroupedTrendItem>;
}

/**
 * Check if a given object implements the GroupedChargingSuccessRateTrendResponse interface.
 */
export function instanceOfGroupedChargingSuccessRateTrendResponse(
    value: object,
): value is GroupedChargingSuccessRateTrendResponse {
    return true;
}

export function GroupedChargingSuccessRateTrendResponseFromJSON(
    json: any,
): GroupedChargingSuccessRateTrendResponse {
    return GroupedChargingSuccessRateTrendResponseFromJSONTyped(json, false);
}

export function GroupedChargingSuccessRateTrendResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): GroupedChargingSuccessRateTrendResponse {
    if (json == null) {
        return json;
    }
    return {
        groups:
            json["groups"] == null
                ? undefined
                : (json["groups"] as Array<any>).map(GroupedTrendItemFromJSON),
    };
}

export function GroupedChargingSuccessRateTrendResponseToJSON(
    value?: GroupedChargingSuccessRateTrendResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        groups:
            value["groups"] == null
                ? undefined
                : (value["groups"] as Array<any>).map(GroupedTrendItemToJSON),
    };
}
